document.addEventListener("click", function(e) {
  const link = e.target.closest('a[href*="#open-chat"]');
  if (link) {
    e.preventDefault();
    const chatElement = document.querySelector("inbox-online-store-chat");
    if (chatElement && chatElement.shadowRoot) {
      const chatButton = chatElement.shadowRoot.querySelector("button");
      if (chatButton) {
        chatButton.click();
      } else {
        console.warn("Chat button not found inside shadowRoot");
      }
    } else {
      console.warn("Chat component not found");
    }
  }
});
